<template>
  <div class="fragment">

<!--    {{ FBM.data.shippingPartnerType }}-->
<!--    <br><br>-->
<!--    {{ FBM.data.shippingPartner }}-->
<!--    <br><br>-->
<!--    {{ FBM.data.shippingAPIPrice }}-->
    <OrdersFBMEditingPage
            v-if="loadUserAuthorizedData && !isAdmin && !advancedUI"
            :FBM="FBM"
            @addProformProduct="addProformProduct"
            @removeProformProduct="removeProformProduct"
            @prepareSaveFBM="prepareSaveFBM"
            @changeUser="changeUser"
    />

    <OrdersFBMAdvancedEditingPage
        v-if="loadUserAuthorizedData && !isAdmin && advancedUI && initData"
        :FBM="FBM"
        @addProformProduct="addProformProduct"
        @removeProformProduct="removeProformProduct"
        @prepareSaveFBM="prepareSaveFBM"
        @changeUser="changeUser"
    />

    <OrdersFBMEditingPageAdmin
            v-if="orderLoading && loadUserAuthorizedData && isAdmin && !reloading && initData"
            :FBM="FBM"
            @reloadEditPage="reloadEditPage"
            @addProformProduct="addProformProduct"
            @removeProformProduct="removeProformProduct"
            @prepareSaveFBM="prepareSaveFBMCheckTrackNum"
            @openOrderNotification="orderNotificationPopup = true; orderNotificationPopupTypeInfo = false"
    />

    <NegativeBalancePopup
            v-if="negativeBalancePopup"
            @close="negativeBalancePopup = false"
    />

    <CommentForAdminPopup
        v-if="commentPopup"
        :FBM="FBM"
        @close="commentPopup = false"
    />

    <OrderNotificationPopup
        v-if="orderNotificationPopup"
        :orderNotificationData="FBM.data.Order.data.orderOBJ ? FBM.data.Order.data.orderOBJ.orderNotification : null"
        :typeInfo="orderNotificationPopupTypeInfo"
        :orderType="'order_fbm'"
        :orderId="FBM.data.Order.data.id"
        @close="orderNotificationPopup = false"
        @reload="reloadNotification"
    />
  </div>
</template>

<script>
  import OrdersFBMEditingPage from "./OrdersFBMEditingPage/OrdersFBMEditingPage";
  import {OrderFBM} from "../../models/OrderFBM";
  import {proformMixins} from "../../../../../mixins/proformMixins/proformMixins";
  import {FBMMixins} from "../../../../../mixins/FBMMixins/FBMMixins";
  import OrdersFBMEditingPageAdmin from "./OrdersFBMEditingPageAdmin/OrdersFBMEditingPageAdmin";
  import {userAvatarMixin} from "../../../../../mixins/usersMixins/userAvatarMixin";
  import {vatNumberMixin} from "../../../../../mixins/commonMixins/vatNumberMixin";
  import NegativeBalancePopup from "../../popups/NegativeBalancePopup/NegativeBalancePopup";
  import {hsCodeMixin} from "../../../../../mixins/commonMixins/hsCodeMixin";
  import {
    AUSTRALIA_ID,
    CANADA_COUNTRY_ID,
    MEXICO_COUNTRY_ID,
    USA_COUNTRY_ID
  } from "../../../../../staticData/staticVariables";
  import OrdersFBMAdvancedEditingPage from "./OrdersFBMAdvancedEditingPage/OrdersFBMAdvancedEditingPage";
  import CommentForAdminPopup
    from "@/components/modules/OrdersFBMModule/popups/CommentForAdminPopup/CommentForAdminPopup";
  import OrderNotificationPopup from "@/components/coreComponents/Popups/OrderNotificationPopup/OrderNotificationPopup";

  export default {
    name: "OrdersFBMEditing",

    components: {
      OrderNotificationPopup,
      OrdersFBMAdvancedEditingPage,
      NegativeBalancePopup,
      OrdersFBMEditingPage,
      OrdersFBMEditingPageAdmin,
      CommentForAdminPopup,
    },

    mixins: [proformMixins, FBMMixins, userAvatarMixin, vatNumberMixin, hsCodeMixin],

    props: {
      easyOrder: {
        type: Boolean,
        default: false,
      }
    },

    watch: {
      getOrderNotification(value) {
        if(value && this.isAdmin) {
          this.orderNotificationPopupTypeInfo = true
          this.orderNotificationPopup = true
        }
      },

      loadUserAuthorizedData: function () {
        this.getFBMUserAuthorizedData()
        this.initFbmOrder()
      },

      selectedCountry(country) {
        if(this.reloading) return

        this.onChangeSelectCountry(country)
      },

      downloadPermissions() {
        this.checkPermission()
      },
    },

    computed: {
      getOrderNotification() {
        return this.FBM.data.Order.data.orderOBJ?.orderNotification?.active === 1
      },
    },

    data() {
      return {
        FBM: new OrderFBM(),

        loadedProformOptions: -1,
        initData: false,

        orderLoading: false,
        negativeBalancePopup: false,
        commentPopup: null,

        reloading: false,
        advancedUI: false,

        isFirstCreateCusClearance: true,

        orderNotificationPopup: false,
        orderNotificationPopupTypeInfo: false,
      }
    },

    mounted() {
      this.FBM.data.vm = this

      if(this.easyOrder) {
        this.FBM.data.easyOrderType = true
      }


      let orderId = this.$route.params.id
      let orderType = this.$route.params.type



      if(this.downloadPermissions){
        if(!this.checkPermission()) return
      }

      /**
       * Set OrderId & TypeFBM from route params
       */
      this.FBM.setOrderId(orderId)
      this.FBM.setTypeFBM(orderType)

      if(this.loadUserAuthorizedData){
        this.advancedUI = this.isExpertUser
        this.initFbmOrder()
      }

      this.$store.dispatch('fetchOrderSize', '?filter[bySizeType]=imperial').then((response) => {
        this.FBM.data.orderSizes = this.getRespPaginateData(response)
      })

    },

    methods: {

      reloadNotification() {
        this.$store.dispatch('getAdminOrdersFBM', this.$route.params.id).then(() => {
          this.FBM.data.Order.data.orderOBJ.orderFbmInstance.orderNotification = this.$store.getters.getConsolidationItem?.orderNotification
        })
      },

      onChangeSelectCountry(country) {
        // this.$store.dispatch('getCountryDataById', country.id).then(() => {
        //   let countryWithCountryGroups = this.$store.getters.getCountryGroup
        //
        //   this.FBM.setVisibleHSCode(this.getHSCodePermissionsByCountry(countryWithCountryGroups, true))
        //   // this.FBM.setVisibleVatNumber(this.getVatNumberPermissionsByCountry(countryWithCountryGroups), this.FBM.data.visibleVatNumber)
        // }).catch(error => this.createErrorLog(error))

        this.FBM.setVisibleHSCode(true)

        if ((country.id === USA_COUNTRY_ID || country.id === AUSTRALIA_ID || country.id === CANADA_COUNTRY_ID || country.id === MEXICO_COUNTRY_ID) && !this.isAdmin) {
          this.$store.dispatch('getRegionsByCountry', country.id).then(() => {
            this.FBM.setRegions(this._.toArray(this.$store.getters.getRegions));
          }).catch(error => this.createErrorLog(error));
        }
      },

      reloadEditPage(openLabel, openGiftFile = false) {
        this.reloading = true
        this.FBM = new OrderFBM()
        this.FBM.data.vm = this

        this.$store.dispatch('fetchOrderSize', '?filter[bySizeType]=imperial').then((response) => {
          this.FBM.data.orderSizes = this.getRespPaginateData(response)
        })

        let orderId = this.$route.params.id
        let orderType = this.$route.params.type

        /**
         * Set OrderId & TypeFBM from route params
         */
        this.FBM.setOrderId(orderId)
        this.FBM.setTypeFBM(orderType)

        this.initFbmOrder().then(() => {
          this.reloading = false

          this.onChangeSelectCountry(this.FBM.getTrsnAddressCountry())

          if(openLabel){
            let routeData = this.$router.resolve({ path: this.$store.getters.GET_PATHS.getPdfFile + '/' + this.FBM.data.Order.data.orderOBJ?.orderFbmInstance?.label_open_file.uuid})

            window.open(routeData.href, '_blank');
          }
          if(openGiftFile){
            let routeData = this.$router.resolve({ path: this.$store.getters.GET_PATHS.getPdfFile + '/' + this.FBM.data.fileGift.uuid})

            window.open(routeData.href, '_blank');
          }
          /**
           * Open Vat file with Label file
           */
          if(openLabel && this.FBM.data.Order.data.orderOBJ?.orderFbmInstance?.vat_tax?.use_vat_id && this.FBM.data.Order.data.orderOBJ?.orderFbmInstance?.vat_tax?.file_entity){
            let routeData = this.$router.resolve({ path: this.$store.getters.GET_PATHS.getPdfFile + '/' + this.FBM.data.Order.data.orderOBJ?.orderFbmInstance?.vat_tax?.file_entity[0].uuid})

            window.open(routeData.href, '_blank');
          }
        })
      },

      initFbmOrder(){

        return this.initializeProductProformArray(this.FBM.data.ProformProducts).then(() => {
          let requestType = 'getOrdersFBMEdit'

          if(this.isAdmin){
            requestType = 'getAdminOrdersFBM'
          }

          if(!this.isAdmin && this.isEasyType) {
            requestType = this.isConsolidation ? 'getEasyOrdersFBMConsolidation' : 'getEasyOrdersFBM'
          }

          return this.$store.dispatch(requestType, this.FBM.data.Order.getId()).then(response => {

            switch (this.getResponseStatus(response)) {
                /**
                 * Success
                 */
              case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {

                let order = this.getRespData(response)

                // this.FBM.data.ddpEUCountries = order?.eu_countries || []


                if(order.show_negative_balance_message_for_admin && this.isAdmin){
                  this.negativeBalancePopup = true
                }

                if(order.orderFbmInstance?.own_label === true && order?.orderFbmInstance?.label_file?.uuid && this.isAdmin && !this.reloading){
                  this.showAdminPopupUserLabel(order?.orderFbmInstance?.label_file)
                }

                if(order?.express_poshta_alert && order.express_poshta_alert.length > 0) {
                  this.notificationAdmin(order.express_poshta_alert)
                }

                if(order.orderFbmInstance?.comment && order.orderFbmInstance?.comment.length > 0 && this.commentPopup === null && this.isAdmin) {
                  this.commentPopup = true
                }


                /**
                 * Set FBM Vat files
                 */
                let vatNumber = order.orderFbmInstance?.vat_tax
                if(vatNumber?.file_entity && vatNumber?.file_entity.length > 0){
                  this.setVatFiles(vatNumber.file_entity)
                }

                // /**
                //  * Set User Label File
                //  */
                // let userLabelFile = order?.orderFbmInstance?.engraving_files
                // if(userLabelFile){
                //   this.setEngravingFile(engravingFiles)
                // }

                /**
                 * Set FBM Photo Products
                 */
                if(order.photos && Object.keys(order.photos).length > 0) {
                  let photo = order.photos
                  this.setProductPhoto(photo)
                }

                return this.$store.dispatch('getConsolidationCreate').then(async response => {

                  let destinationData = this.getRespData(response)?.destinations

                  await this.$store.dispatch('getOrdersFBMProcessFee').then(ordersFBMProcessFee => {
                    this.FBM.data.orderFbmFees = this.isConsolidation ? this.getRespData(ordersFBMProcessFee)?.fee_self_create_label :
                        this.getRespData(ordersFBMProcessFee)?.fee_order_fbm
                  })


                  /**
                   * Set FBM
                   */
                  this.FBM.setItem(order, this.isAdmin, false, destinationData)

                  /**
                   * Set Engraving Files
                   */

                  if(order?.orderFbmInstance?.engravings[0]?.width) {
                    order?.orderFbmInstance?.engravings.forEach((engravingItem, engravingIndex) => {
                      if(engravingItem.files.length === 0) {
                        let engravingFiles = order?.orderFbmInstance?.engraving_files
                        if(engravingFiles){
                          this.setEngravingFile(engravingFiles, engravingIndex)
                        }
                      } else {
                        this.setEngravingFile(engravingItem.files, engravingIndex)
                      }
                    })
                  }



                  /**
                   * Set Embroidery Files
                   */
                  let embroideryFiles = order?.orderFbmInstance?.embroidery_files
                  if(embroideryFiles){
                    this.setEmbroideryFile(embroideryFiles)
                  }

                  /**
                   * Set T-Shirt Painting Files
                   */
                  let tshirtPaintingFiles = order?.orderFbmInstance?.tshirt_painting_files
                  if(tshirtPaintingFiles){
                    this.setTShirtPaintingFile(tshirtPaintingFiles)
                  }

                  /**
                   * Set Photo Print Files
                   */
                  let photoPrintFiles = order?.orderFbmInstance?.photo_print_files
                  if(photoPrintFiles){
                    this.setPhotoPrintFilesFile(photoPrintFiles)
                  }

                  /**
                   * Set Leather Stamping Files
                   */
                  let leatherStampingFiles = order?.orderFbmInstance?.leather_stamping_files
                  if(leatherStampingFiles){
                    this.setLeatherStampingFile(leatherStampingFiles)
                  }

                  /**
                   * Set Leather Stamping Files
                   */
                  let UVPrintingFiles = order?.orderFbmInstance?.customization_print_u_v_files
                  if(UVPrintingFiles){
                    this.setUVPrintingFile(UVPrintingFiles)
                  }

                  /**
                   * Set permanent vinyl files
                   */
                  if(order?.orderFbmInstance?.permanent_vinyls[0]?.need_dm_pv) {
                    order?.orderFbmInstance?.permanent_vinyls.forEach((customItem, customIndex) => {
                      this.setPermanentVinylFile(customItem.files, customIndex)
                    })
                  }

                  /**
                   * Set sticker files
                   */
                  if(order?.orderFbmInstance?.stickers[0]?.need_sticker) {
                    order?.orderFbmInstance?.stickers.forEach((customItem, customIndex) => {
                      this.setStickerFile(customItem.files, customIndex)
                    })
                  }

                  /**
                   * Set heat transfer vinyl files
                   */
                  if(order?.orderFbmInstance?.heat_transfer_vinyls[0]?.need_htv) {
                    order?.orderFbmInstance?.heat_transfer_vinyls.forEach((customItem, customIndex) => {
                      this.setHeatTransferVinylFile(customItem.files, customIndex)
                    })
                  }

                  /**
                   * Set FBM Proform Products
                   */
                  this.FBM.data.ProformProducts.map((itemProduct, index) => {
                    this.initialProformSelectOptions({
                      val: itemProduct.product.proformData.proformCategory,
                      item: itemProduct
                    }).then(() => {
                      this.loadedProformOptions = index
                    })
                  })

                  if(this.isAdmin){
                    this.setUserAvatar(this.FBM.data.User)
                  }
                  if (this.isAdmin && !this.isStatusComplete(this.FBM.data.Order.getStatus().value) && this.getUserPlannedDateConsolidation && this.isConsolidation) {
                    this.FBM.setReceivedAt(this.$moment(this.getUserPlannedDateConsolidation).format('YYYY-MM-DD'))
                  }
                  if (this.isAdmin && !this.isStatusComplete(this.FBM.data.Order.getStatus().value) && this.getUserPlannedDateWarehouse && this.isWarehouse) {
                    this.FBM.setReceivedAt(this.$moment(this.getUserPlannedDateWarehouse).format('YYYY-MM-DD'))
                  }
                  if (this.advancedUI && !this.isAdmin && this.$store.getters.GET_COMMON_AUTHORIZED?.user?.small_avatar_file
                      && this.$store.getters.GET_COMMON_AUTHORIZED?.user?.small_avatar_file.length > 0) {
                    this.FBM.data.User.user.avatar_files = this.$store.getters.GET_COMMON_AUTHORIZED?.user?.small_avatar_file
                    this.setUserAvatar(this.FBM.data.User)
                  }

                  this.orderLoading = true
                  this.initData = true

                  this.checkIsConsoWithProductsAndAdmin()

                }).catch(error => this.createErrorLog(error))

              }
                /**
                 * Validation Error
                 */
              case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
                let errors = response.response.data.errors;
                this.notifyErrorHelper(errors)
                this.$router.push(this.$store.getters.GET_PATHS.ordersFBM)
                break
              }
                /**
                 * Undefined Error
                 */
              default: {
                this.openNotify('error', 'common_notificationUndefinedError')
              }
            }


          }).catch(error => this.createErrorLog(error))
        })
      },

      getFBMUserAuthorizedData() {

      },

      checkIsConsoWithProductsAndAdmin() {
        if(this.isConsolidation && this.FBM.data.productsForCellArray.length > 0 && this.isAdmin) {
          let text = {
            title: 'common_orderHasProducts',
            txt: '',
            yes: '',
            no: 'common_close'
          }

          let confirm = () => {
            return true
          }

          this.deleteFunc(text, confirm)
        }
      },

      showAdminPopupUserLabel(fileLabel) {
        let text = {
          title: 'common_userHasLabelPopup',
          txt: '',
          yes: 'common_userHasLabelDownload',
          no: 'common_close'
        }

        let confirm = () => {
          window.open(this.$store.getters.GET_PATHS.getPdfFile + '/' + fileLabel?.uuid, '_blank')
          return true
        }

        this.deleteFunc(text, confirm)
      },

      notificationAdmin() {
        let text = {
          title: 'common_attentionPaid',
          txt: '',
          no: 'common_close'
        }

        let confirm = () => {
          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

      addProformProduct(){
        let newIndex = this.FBM.addProformProduct()
        this.initializeProductProformArray(this.FBM.data.ProformProducts, newIndex)
      },

      removeProformProduct(index) {
        this.FBM.removeProformProduct(index)
      },

      prepareSaveFBMCheckTrackNum(data) {

        if(this.FBM.data.Order.getTrackingNum() === '' && this.isStatusComplete(this.FBM.data.Order.getStatus().value) && !this.FBM.data.useEasyPost){
          let text = {
            title: 'fbm_DidNotSetTrackNumber',
            txt: '',
            yes: 'common_save',
            no: 'common_confirmNo'
          }

          let confirm = () => {

            this.prepareSaveFBM(data)

            this.$store.commit('setConfirmDeletePopup', false)
            return true
          }

          this.deleteFunc(text, confirm)
          return
        }

        this.prepareSaveFBM(data)
      },

      // saveFBM({draft = false, edit = false, createLabel = false}) {
      //   console.log(createLabel);
      //   if(this.isAdmin) {
      //     if(!this.FBM.dataAdminValidation()) return
      //   }
      //
      //   let data = this.FBM.prepareFBM(
      //     draft,
      //     this.FBM.data.User.getUserId()
      //   )
      //
      //   console.log(data);
      //
      //   if(draft){
      //     let confirm = () => {
      //       this.saveOrderFBM(draft, edit, data, 'consolidation').then(status => {
      //         this.successSave(status)
      //       })
      //
      //       this.$store.commit('setSaveInDraftsPopup', false)
      //       return true
      //     }
      //
      //     this.saveInDraftsFunc(confirm)
      //   } else {
      //     console.log(3423);
      //     // this.saveOrderInternal(draft, edit, data, 'ukrposhta').then(response => {
      //     //   this.createLabel(response.id)
      //     //   return true
      //     // })
      //   }
      //
      //
      //
      // },


      // successSave(status) {
      //   if(!status) return
      //
      //   this.$router.push(this.$store.getters.GET_PATHS.ordersFBM)
      // }

    },

  }
</script>

<style scoped>

</style>
